import styled, { css } from "styled-components";

export const StyledCredit = styled.p`
  position: absolute;
  z-index: 100;
  left: 2rem;
  top: 90vh;
  display: flex;
  flex-direction: row;
  padding: 0 2rem;
  word-spacing: 0.5vw;
`;
export const StyledCreditLink = styled.a`
  text-decoration: none;
  color: inherit;
  font-weight: 700;
  padding: 0 0.5rem;
`;
